"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../theming/theme.pricing-system");

var rule_details_text_field_1 = require("../rule-details/rule-details-text-field");

var selector_1 = require("../rule-details/selector");

var PriceLookupView = function (_super) {
  __extends(PriceLookupView, _super);

  function PriceLookupView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PriceLookupView.prototype.renderLookupValues = function () {
    return react_1.default.createElement(react_native_1.ScrollView, {
      style: theme_pricing_system_1.pricingStyles.dataContainerView
    });
  };

  PriceLookupView.prototype.onChangeDaysSupply = function () {
    return;
  };

  PriceLookupView.prototype.render = function () {
    return react_1.default.createElement(react_native_1.View, {
      style: {
        flex: 1,
        margin: 5
      }
    }, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.titleText
    }, "Price Lookup"), react_1.default.createElement(react_native_1.View, {
      style: {
        flex: 1
      }
    }, react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.inputContainerView
    }, react_1.default.createElement(react_native_1.View, null, react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.flexRow
    }, react_1.default.createElement(rule_details_text_field_1.TextField, {
      label: 'NDC: ',
      id: '456'
    }), react_1.default.createElement(selector_1.Selector, {
      selectorId: "daysSupplyDetails",
      selectorItemList: [{
        id: '30',
        label: '30'
      }, {
        id: '90',
        label: '90'
      }],
      onChangeItem: this.onChangeDaysSupply,
      selectorLabel: "Days Supply"
    })))), this.renderLookupValues()));
  };

  return PriceLookupView;
}(react_1.default.Component);

exports.PriceLookupView = PriceLookupView;